import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import "./Dashboard.css";

const Dashboard = ({ isSidebarOpen }) => {
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const hasValidReport = state?.embedToken && state?.embedUrl && state?.reportUrl;

  const embedConfig = hasValidReport ? {
    type: 'report',
    id: state.reportUrl,
    embedUrl: state.embedUrl,
    accessToken: state.embedToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
    },
  } : null;

  const eventHandlers = new Map([
    ['loaded', () => {
      console.log('Report loaded');
      setIsLoading(false);
    }],
    ['rendered', () => console.log('Report rendered')],
    ['error', (event) => {
      console.error('Power BI Error:', event.detail);
      setIsLoading(false);
    }],
  ]);

  const getEmbeddedComponent = (embeddedReport) => {
    window.report = embeddedReport;
  };

  return (
     <div className={`powerbi-wrapper ${isSidebarOpen ? 'with-sidebar' : 'full-width'}`}>     
      {!state && (
        <div className="welcome-message">
          <h2>Welcome to the Dashboard</h2>
          <p>Please select a department and report to view data.</p>
        </div>
      )}

      {hasValidReport && embedConfig && (
        <>
          {isLoading && <div className="loading">Loading report...</div>}
          <PowerBIEmbed
            embedConfig={embedConfig}
            eventHandlers={eventHandlers}
            cssClassName="powerbi-container"
            getEmbeddedComponent={getEmbeddedComponent}
          />
        </>
      )}

      {state && !hasValidReport && (
        <div className="no-report">
         
        </div>
      )}
    </div>
  );
};

export default Dashboard;
